import { Chip, Icon } from "@silversea-ssc/ui-components-react";
import clsx from "clsx";
import React, { ComponentProps, PropsWithChildren } from "react";
import * as styles from "./ExpiresOnChip.module.scss";

type Props = {
  background: ComponentProps<typeof Chip>["background"];
  className?: string;
};

const ExpiresOnChip: React.FC<PropsWithChildren<Props>> = ({
  children,
  className,
  background
}) => {
  return (
    <div className={clsx(className, styles.container)}>
      <Chip background={background} className={styles.chip}>
        <Icon name="alarm-clock" className={styles.icon} padding={false} />
        {children}
      </Chip>
    </div>
  );
};

export default ExpiresOnChip;
